/*  PATH ÖN EKİ  ——›  { module_key, required }  
    required  ➜  "sort_permission" | "view_permission" | "create_permission"
                 | "edit_permission" | "trash_permission"
*/
export const ROUTE_RULES = {
    // ───────── USERS (static_users) ─────────
    "/customers/list"            : { module_key: "static_users", required: "sort_permission" },
    "/customers/trash"           : { module_key: "static_users", required: "trash_permission" },
    "/customers/view"            : { module_key: "static_users", required: "view_permission" },
    "/customers/create"          : { module_key: "static_users", required: "create_permission" },
  
    // ───────── LEADS (static_admin_accounts) ─────────
    "/leads/list"                : { module_key: "static_admin_accounts", required: "sort_permission" },
    "/leads/trash"               : { module_key: "static_admin_accounts", required: "trash_permission" },
    "/leads/view"                : { module_key: "static_admin_accounts", required: "view_permission" },
    "/leads/create"              : { module_key: "static_admin_accounts", required: "create_permission" },
  
    // ───────── ROLES (static_roles) ─────────
    "/admin/roles"               : { module_key: "static_roles", required: "sort_permission" },
    "/admin/roles/trash"         : { module_key: "static_roles", required: "trash_permission" },
    "/admin/roles/view"          : { module_key: "static_roles", required: "view_permission" },
    "/admin/roles/create"        : { module_key: "static_roles", required: "create_permission" },
    "/admin/roles/edit"          : { module_key: "static_roles", required: "edit_permission" },
  

    /* ───────── LANGUAGE OPTIONS (static_language_options) ───────── */
  "/admin/language"            : { module_key: "static_language_options", required: "sort_permission" },
  "/admin/language/view"       : { module_key: "static_language_options", required: "view_permission" },
  "/admin/language/create"     : { module_key: "static_language_options", required: "create_permission" },
  "/admin/language/edit"       : { module_key: "static_language_options", required: "edit_permission" },
  "/admin/language/translation": { module_key: "static_language_options", required: "edit_permission" },

  /* ───────── SITE REDIRECT (static_site_redirect) ───────── */
  "/admin/website"             : { module_key: "static_site_redirect", required: "sort_permission" },
  "/admin/website/view"        : { module_key: "static_site_redirect", required: "view_permission" },
  "/admin/website/create"      : { module_key: "static_site_redirect", required: "create_permission" },
  "/admin/website/edit"        : { module_key: "static_site_redirect", required: "edit_permission" },
  
    // ───────── VERSIONS (static_version) ─────────
    "/version/list"              : { module_key: "static_version", required: "sort_permission" },
    "/version/trash"             : { module_key: "static_version", required: "trash_permission" },
    "/version/view"              : { module_key: "static_version", required: "view_permission" },
    "/version/create"            : { module_key: "static_version", required: "create_permission" },
    "/version/edit"              : { module_key: "static_version", required: "edit_permission" },
  
    // ───────── MAIL‑TEMPLATES (static_mail_template) ─────────
    "/leads/mail"                : { module_key: "static_mail_template", required: "sort_permission" },
    "/mail-templates/trash"      : { module_key: "static_mail_template", required: "trash_permission" },
    "/mail-templates/view"       : { module_key: "static_mail_template", required: "view_permission" },
    "/mail-templates/create"     : { module_key: "static_mail_template", required: "create_permission" },
    "/mail-templates/edit"       : { module_key: "static_mail_template", required: "edit_permission" },
  
    // ───────── URL‑REDIRECT (static_url_redirect) ─────────
    "/settings/site"             : { module_key: "static_url_redirect", required: "sort_permission" },
    "/settings/definition"       : { module_key: "static_definitions", required: "sort_permission" },
    "/definition/edit"           : { module_key: "static_definitions", required: "edit_permission" },
    "/redirect/edit"             : { module_key: "static_url_redirect", required: "edit_permission" },
  
    // ───────── MODULES (static_modules) + dinamik slug'lar ─────────
    "/admin/modules"             : { module_key: "static_modules", required: "sort_permission" },
    "/admin/modules/trash"       : { module_key: "static_modules", required: "trash_permission" },
    "/admin/modules/create"      : { module_key: "static_modules", required: "create_permission" },
    "/admin/modules/list"        : { module_key: "static_modules", required: "sort_permission" },
    "/admin/modules/edit"        : { module_key: "static_modules", required: "edit_permission" },
    "/admin/navigation/status"   : { module_key: "static_navigate", required: "sort_permission" },
  
    // Dinamik modül slug’ları (/modules/:slug …)  
    // Burada kontrolü basitleştirmek adına hepsi "sort_permission" istiyor:
    "/modules"                   : { dynamic: true, required: "sort_permission" },
  
    // Diğer settings sayfalarının hepsi geliştirici ayarları:
    "/settings"                  : { module_key: "static_admin_accounts", required: "sort_permission" },
  };
  